import { StrictMode, lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import Theme from "./Theme";
import LoadingWithBrand from "./core/LoadingWithBrand";

const App = lazy(() => import("./Startup"));

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider theme={Theme}>
      <CssBaseline>
        <Suspense fallback={<LoadingWithBrand />}>
          <App />
        </Suspense>
      </CssBaseline>
    </ThemeProvider>
  </StrictMode>
);
